import moment from "moment";
import React, { useEffect, useState } from "react";
import { useRef } from "react";
import ReactDatePicker from "react-datepicker";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import GetSvgIcon, { GetSvgUpload } from "../../../images/svglist";
import { initValPartnerPrf } from "../../ApprovalWorkFlow/Partner/initValPartnerPrf";
import { getUserInfo, setUserInfo } from "../../AuthUtils/AuthUtils";
import {
  getFileName,
  toBase64,
  approvalHistory,
  permission,
} from "../../Helper/CommonMethods";
import Select from "react-select";
import {
  ALPHANUM,
  ALPHANUM_NAME,
  COUNTRY_CODES,
  DATE_FORMAT_CLIENT,
  PATTERN_ERR_MSG,
  REQUIRED_ERR_MSG,
  PHONE_NUM,
  SERVER_ERR_MSG,
} from "../../Helper/Constants";
import { CallApiGet, CallApiPost } from "../../Helper/serviceApi";
import Header from "../../Layout/Header";
import Popup from "../../Layout/Popup";
import Spinner from "../../Layout/Spinner";
import { DownloadFile, GetBase64Img } from "../../Helper/FileStoreService";
import ApprovalLogList from "../../ApprovalWorkFlow/ApprovalLogList";
import { APVLLOG } from "../../../ConfigConstants/ConfigConstants";
const initialVhclType = {
  id: 0,
  vhclType: "",
  vhclSize: 0,
  maxWeight: 0,
  maxPallets: 0,
  palletHeight: 0,
  palletWeight: 0,
  maxPalletWeight: 0,
};

const initImgData = {
  vhclImgF: "",
  vhclImgB: "",
  vhclImgL: "",
  vhclImgR: "",
  vhclImgI: "",
};
const initPhotoFile = {
  photo: "",
  photoFileType: "",
  photoBucketUrl: "",
  photoFileName: "",
};

export const NUMBER_REGEX = /^[0-9]*$/;

export default function DriverProfile() {
  const [driverProfile, setDriverProfile] = useState(
    JSON.parse(JSON.stringify(initValPartnerPrf))
  );
  const [vhclTypes, setVhclTypes] = useState([initialVhclType]);
  const [reload, setReload] = useState(0);
  const [isSuccess, setIsSuccess] = useState(false);
  const [description, setDescription] = useState();
  const [title, setTitle] = useState();
  const [isUserActive, setIsUserActive] = useState(false);
  const [show, setShow] = useState(false);
  const [approvalHistoryData, setApprovalHistoryData] = useState();
  const [imgData, setImgData] = useState(
    JSON.parse(JSON.stringify(initImgData))
  );
  const [userType, setUserType] = useState();
  const modalRef = useRef();
  const callback = () => {
    setReload((reload) => reload + 1);
  };
  const [isDisabled, setDisabled] = useState({});
  const [photoImg, setPhotoImg] = useState();
  const [photoFile, setPhotoFile] = useState(initPhotoFile);
  const [imageData, setImageData] = useState(initPhotoFile);
  const navigate = useNavigate();
  useEffect(() => {
    const userType = getUserInfo("userType");
    setIsUserActive(getUserInfo("userActive"));
    fetchDriverDetails(userType);
    // loadVhclTypes();
    setUserType(userType);
  }, [reload]);

  const {
    register,
    setValue,
    watch,
    handleSubmit,
    control,
    reset,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: driverProfile,
  });
  const { fields: userInfos } = useFieldArray({
    control,
    name: "userInfoList",
  });
  const { fields: vhclList } = useFieldArray({
    control,
    name: "vehicleList",
  });

  const downloadVehicleimage = async (vehicle) => {
    GetBase64Img(vehicle?.vhclImgF?.photoFileName).then((resp) => {
      setImgData((img) => ({
        ...img,
        vhclImgF: resp,
      }));
    });
    GetBase64Img(vehicle?.vhclImgB?.photoFileName).then((resp) => {
      setImgData((img) => ({
        ...img,
        vhclImgB: resp,
      }));
    });
    GetBase64Img(vehicle?.vhclImgL?.photoFileName).then((resp) => {
      setImgData((img) => ({
        ...img,
        vhclImgL: resp,
      }));
    });
    GetBase64Img(vehicle?.vhclImgR?.photoFileName).then((resp) => {
      setImgData((img) => ({
        ...img,
        vhclImgR: resp,
      }));
    });
    GetBase64Img(vehicle?.vhclImgI?.photoFileName).then((resp) => {
      setImgData((img) => ({
        ...img,
        vhclImgI: resp,
      }));
    });
  };

  const fetchDriverDetails = async (userType) => {
    let uri = `GetPartnerProfile?profileId=${getUserInfo(
      "acctId"
    )}&roleId=0&userType=${userType}`;
    setShow(true);
    let data = await CallApiGet(uri);
    setShow(false);
    if (data.respCode === 200 || data.respCode === 0) {
      setDriverProfile(data.respData);
      setUserInfo("userName", data.respData.driverName);
      let partnerPrflDetails = data.respData;

      reset(partnerPrflDetails);
      setValue("phoneCode", partnerPrflDetails.phone.substr(0, 3));
      setValue("phone", partnerPrflDetails.phone.substr(3));
      // downloadVehicleimage(partnerPrflDetails.vehicleList[0]);
    } else {
    }
  };
  const selectFile = async (key, event) => {
    let newAttachment = {};
    const file = event.target.files;

    if (file.length === 0) {
      newAttachment = {
        photo: "",
        photoFileName: "",
        photoFileType: "",
        photoBucketUrl: "",
      };
    } else {
      var fileName = file[0].name;
      var ext = fileName.substr(fileName.lastIndexOf(".") + 1);
      var photo = "";
      try {
        photo = await toBase64(file[0]);
      } catch (error) {
        console.error(error);
      }

      newAttachment = {
        photo: photo,
        photoFileName: fileName,
        photoFileType: ext,
        photoBucketUrl: fileName,
      };
    }
    setValue(`${key}.photo`, newAttachment.photo);
    setValue(`${key}.photoFileName`, newAttachment.photoFileName);
    setValue(`${key}.photoFileType`, newAttachment.photoFileType);
    setValue(`${key}.photoBucketUrl`, newAttachment.photoBucketUrl);
    clearErrors(key);
  };

  const loadVhclTypes = async () => {
    let data = await CallApiGet("getAllVhclTypes");
    if (data.respCode === 200 || data.respCode === 0) {
      let tempArr = [];
      const vhclTypesArr = data.respData;
      vhclTypesArr.forEach((element) => {
        tempArr.push({
          label: element.vhclType,
          value: element.id,
        });
      });
      setVhclTypes(tempArr);
    } else if (data.respCode === 400 || data.respCode === 401) {
      setIsSuccess(false);
      setTitle("UNAUTHORIZED");
      setDescription("Sorry, you don't have the read permission!!");
      modalRef.current.click();
    } else {
      console.error(data);
      // onError()
    }
  };

  const onSubmit = async (data) => {
    setShow(true);
    if (data.phone !== "") {
      data.phone = data.phoneCode + data.phone;
    }
    delete data.phoneCode;
    data?.userInfoList?.forEach((e) => {
      if (e.infoCode === 125) {
        if (data?.profilePhoto?.photo?.length > 0) {
          e.infoAttachment = data.profilePhoto
        }
      }
    })
    const uri = `savePartnerProfile?userType=${userType}`;
    let resp = await CallApiPost(uri, data);
    setShow(false);
    if (resp.respCode === 200 || resp.respCode === 0) {
      onSuccess("Profile details updated successfully !!!");
    } else if (data.respCode === 400 || data.respCode === 401) {
      setIsSuccess(false);
      setTitle("UNAUTHORIZED");
      setDescription("Sorry, you don't have the write permission!!");
      modalRef.current.click();
    } else {
      onFailure();
    }

    console.log(data);
  };
  const onSuccess = (sucMsg) => {
    setIsSuccess(true);
    setTitle("Congratulations");
    setDescription(sucMsg);
    modalRef.current.click();
  };

  const onFailure = () => {
    setIsSuccess(false);
    setTitle("Error");
    setDescription(SERVER_ERR_MSG);
    modalRef.current.click();
  };
  const onError = (error) => {
    console.log(error);
  };

  const handleCancel = () => {
    navigate("/home");
  };

  const getApprovalHistory = async () => {
    setShow(true);
    let approvalHistoryData = await approvalHistory(
      driverProfile.partnerId,
      driverProfile.approvalUserTypeId
    );
    setShow(false);
    if (approvalHistoryData.respCode === 200) {
      let data = approvalHistoryData.respData;
      setApprovalHistoryData(data);
    } else if (approvalHistoryData.respCode === 500) {
      onFailure();
    } else {
      setApprovalHistoryData([]);
      localStorage.clear();
      navigate("/home");
    }
  };

  const vhclPhotoFPlaceHolder = watch(
    "vehiclePhotoFront.photoFileName",
    "Upload Truck Front Photo"
  );
  const vhclPhotoRPlaceHolder = watch(
    "vehiclePhotoRight.photoFileName",
    "Upload Truck Right Photo"
  );
  const vhclPhotoLPlaceHolder = watch(
    "vehiclePhotoLeft.photoFileName",
    "Upload Truck Left Photo"
  );
  const vhclPhotoBPlaceHolder = watch(
    "vehiclePhotoBack.photoFileName",
    "Upload Truck Back Photo"
  );
  const vhclPhotoIPlaceHolder = watch(
    "vehiclePhotoInternal.photoFileName",
    "Upload Truck Internal Photo"
  );
  const sucs = () => { };
  const download = (fileName) => {
    if (fileName !== "") {
      setShow(true);
      DownloadFile(fileName, sucs, sucs);
      setShow(false);
    }
  };
  const selectPhotoFile = async (event) => {
    const file = event.target.files;

    if (file.length === 0) {
    } else {
      var fileName = file[0].name;
      setPhotoImg(file[0]);
      var ext = fileName.substr(fileName.lastIndexOf(".") + 1);
      var photo = "";
      try {
        photo = await toBase64(file[0]);
      } catch (error) {
        console.error(error);
      }

      const newAttachment = {
        photo: photo,
        photoFileType: ext,
        photoBucketUrl: "",
        photoFileName: fileName,
      };
      setPhotoFile(newAttachment);
      setValue("profilePhoto", newAttachment);
      // clearErrors("profileDoc");
      // setPhotoImgErrMsg();
    }
  };
  useEffect(() => {
    let profileUrl = driverProfile?.userInfoList.find((e) => e.infoCode === 125)?.infoAttachment?.photoBucketUrl
    if (profileUrl && profileUrl !== "") {
      setImageData(profileUrl);
    } else {
      setImageData("");
    }
  }, [driverProfile])
  return (
    <div>
      <Header />
      <div className="container-fluid min-ht-100">
        <div className="row">
          <main className="col-md-12 p-3">
            <div className="mt-2">
              <div className="col-md-2 d-none">
                <nav className="nav flex-column profile-action" id="nav-tab">
                  <button
                    className="nav-link active"
                    id="nav-RegisteredCustomer-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-RegisteredCustomer"
                    type="button"
                    role="tab"
                    aria-controls="nav-RegisteredCustomer"
                    aria-selected="true"
                  >
                    Personal Details
                  </button>
                  <button
                    className="nav-link"
                    id="nav-ISR-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-ISR"
                    type="button"
                    role="tab"
                    aria-controls="nav-ISR"
                    aria-selected="false"
                  >
                    Company Details
                  </button>
                  <button
                    className="nav-link"
                    id="nav-Finance-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-Finance"
                    type="button"
                    role="tab"
                    aria-controls="nav-Finance"
                    aria-selected="false"
                  >
                    Bank Details
                  </button>
                  <button
                    className="nav-link"
                    id="way-bill-details-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#way-bill-details"
                    type="button"
                    role="tab"
                    aria-controls="way-bill-details"
                    aria-selected="false"
                  >
                    Waybill Details
                  </button>
                  <button
                    className="nav-link"
                    id="pickup-details-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#pickup-details"
                    type="button"
                    role="tab"
                    aria-controls="pickup-details"
                    aria-selected="false"
                  >
                    Pickup Details
                  </button>
                  <button
                    className="nav-link"
                    id="password-details-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#password-details"
                    type="button"
                    role="tab"
                    aria-controls="password-details"
                    aria-selected="false"
                  >
                    Password Details
                  </button>
                </nav>
              </div>
              <div className="col-md-12 ">
                <div className="alert alert-info">
                  <div>
                    <div className="float-start">
                      <h5 className="card-title">Current Approval Status:</h5>
                      <p className="card-text">{driverProfile.approveStatus}</p>
                    </div>
                    {permission(APVLLOG).allowedRead && (
                      <button
                        type="button"
                        className="btn btn-outline-secondary theme-violet me-1 float-end"
                        onClick={getApprovalHistory}
                        data-bs-toggle="modal"
                        data-bs-target="#approval-history-modal"
                      >
                        Approval History
                      </button>
                    )}
                    <div className="clearfix"></div>
                  </div>
                </div>
                <div className="row" id="nav-tabContent">
                  <div className="col-md-12 mb-4">
                    <div
                      className="tab-pane d-block show border border-2 p-2"
                      id="nav-RegisteredCustomer"
                      role="tabpanel"
                      aria-labelledby="nav-RegisteredCustomer-tab"
                    >
                      <h5 className="theme-violet-txt">Personal Details</h5>
                      <div className="row">
                        <div className="col-md-4 mb-2">
                          <input type="hidden" {...register("partnerId")} />
                          <div
                            className="mb-1 file-placeholder thumbnail-pic d-flex justify-content-center"
                            {...register("profilePhoto")}
                          >
                            <input
                              type="file"
                              accept="image/png, image/jpeg "
                              onChange={selectPhotoFile}
                            />
                            {photoImg ? (
                              <img
                                src={URL.createObjectURL(photoImg)}
                                alt="img"
                              />
                            ) : imageData !== "" ? (
                              <img
                                src={
                                  imageData !== ""
                                    ? imageData
                                    : ""
                                }
                                alt="img"
                              />
                            ) : (
                              <div>
                                Upload Photo{" "}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-4 mb-2">
                          <label
                            htmlFor=""
                            className="form-label theme-label"
                            data-toggle="tooltip"
                            data-placement="right"
                            title="This field is mandatory"
                          >
                            Driver Name
                            <span className="text-danger">&#9733;</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="driverName"
                            defaultValue={driverProfile.driverName}
                            {...register("driverName", {
                              required: {
                                value: true,
                                message: REQUIRED_ERR_MSG,
                              },
                            })}
                            maxLength="200"
                          />
                          {errors.driverName && (
                            <div>
                              <span className="badge bg-danger">
                                &#9888; {errors.driverName.message}
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="col-md-4 mb-2">
                          <label
                            htmlFor=""
                            className="form-label theme-label"
                            title="This field is mandatory"
                          >
                            Driver address{" "}
                            <span className="text-danger">&#9733;</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            defaultValue={driverProfile.address}
                            {...register("address", {
                              required: {
                                value: true,
                                message: REQUIRED_ERR_MSG,
                              },
                            })}
                            maxLength="200"
                          />
                          {errors.address && (
                            <div>
                              <span className="badge bg-danger">
                                &#9888; {errors.address.message}
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="col-md-4 mb-2">
                          <label
                            htmlFor=""
                            className="form-label theme-label"
                            title="This field is mandatory"
                          >
                            Email <span className="text-danger">&#9733;</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            defaultValue={driverProfile.email}
                            {...register("email")}
                            maxLength="100"
                            disabled
                          />
                        </div>
                        <div className="col-md-4 mb-2">
                          <label
                            htmlFor=""
                            className="form-label theme-label"
                            title="This field is mandatory"
                          >
                            Phone <span className="text-danger">&#9733;</span>
                          </label>
                          <div className="input-group">
                            <select
                              name="phoneCode"
                              {...register("phoneCode")}
                              defaultValue="+60"
                              className="form-control country-code-customize"
                            >
                              {COUNTRY_CODES.map((cc, index) => (
                                <option key={index} value={cc.value}>
                                  {cc.label}
                                </option>
                              ))}
                            </select>
                            <input
                              type="text"
                              className="form-control"
                              maxLength="11"
                              //defaultValue={driverProfile.phone}
                              {...register("phone", {
                                required: {
                                  value: true,
                                  message: REQUIRED_ERR_MSG,
                                },
                                pattern: {
                                  value: PHONE_NUM,
                                  message: PATTERN_ERR_MSG,
                                },
                              })}
                            />
                            {errors.phone && (
                              <div>
                                <span className="badge bg-danger">
                                  &#9888; {errors.phone.message}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-4 mb-2">
                          <label
                            htmlFor=""
                            className="form-label theme-label"
                            title="This field is mandatory"
                          >
                            State <span className="text-danger">&#9733;</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="state"
                            defaultValue={driverProfile.state}
                            {...register("state")}
                            maxLength="50"
                            disabled
                          />
                        </div>
                        <div className="col-md-4 mb-2">
                          <label
                            htmlFor=""
                            className="form-label theme-label"
                            title="This field is mandatory"
                          >
                            City <span className="text-danger">&#9733;</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="city"
                            defaultValue={driverProfile.city}
                            {...register("city")}
                            maxLength="50"
                            disabled
                          />
                        </div>
                        <div className="col-md-4 mb-2">
                          <label
                            htmlFor=""
                            className="form-label theme-label"
                            title="This field is mandatory"
                          >
                            Postal Code{" "}
                            <span className="text-danger">&#9733;</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="postCode"
                            defaultValue={driverProfile.postCode}
                            {...register("postCode", {
                              required: {
                                value: true,
                                message: REQUIRED_ERR_MSG,
                              },
                              pattern: {
                                value: ALPHANUM,
                                message: PATTERN_ERR_MSG,
                              },
                            })}
                            maxLength="50"
                            disabled
                          />
                          {errors.postCode && (
                            <div>
                              <span className="badge bg-danger">
                                &#9888; {errors.postCode.message}
                              </span>
                            </div>
                          )}
                        </div>
                        {/* </div> */}
                        <div className="clearfix"> </div>
                      </div>
                    </div>
                  </div>

                  <div className="clearfix"></div>

                  <div className="w-100 text-end mt-2">
                    <button
                      data-bs-toggle="modal"
                      data-bs-target="#success-modal"
                      id="modalPopup"
                      className="d-none"
                      ref={modalRef}
                    />
                    {isUserActive === "true" && (
                      <button
                        type="button"
                        className="btn btn-default border"
                        data-bs-dismiss="modal"
                        onClick={handleCancel}
                      >
                        Cancel
                      </button>
                    )}
                    <button
                      type="submit"
                      className="btn btn-outline-secondary theme-violet"
                      onClick={handleSubmit(onSubmit, onError)}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
      <ApprovalLogList data={approvalHistoryData} />
      <Spinner show={show} />
      <Popup
        isSuccess={isSuccess}
        title={title}
        description={description}
        handler={callback}
      />
    </div>
  );
}
